export const ETitleColor = {
    WHITE:'text-white',
    DEFAULT:'text-black',
    RED:'text-[#de0034]',
}


export const ETitleBackground = {
    BLACK:'bg-black',
    RED:'bg-[#de0034]',
    DEFAULT: 'bg-none'
}

export const ETitlePosition = {
    CENTER:'text-center',
    LEFT:'',
    ROW:'',
    RIGHT:'text-right font-normal',
}

export const ESubTitlePosition = {
    RIGHT:'',
    BOTTOM:'flex flex-col',
    NONE:'',
}

export const ETextSize = {
    LARGE:'text-[25px] sm:text-[28px] md:text-[32px]',
    MEDIUM:'text-[17px] sm:text-[20px] md:text-[24px]',
    SMALL:'text-[13px] sm:text-[16px] md:text-[20px]',
}

export const ETextWeight = {
    BOLD:'font-bolder',
    LIGHTBOLD:'font-lightbold',
}

export const EWrapperType = {
    ROW:'flex justify-between items-start w-5/6 mx-auto',
    LEFT:'w-fit px-[30px] py-[13px]',
    CENTER:'',
    RIGHT:'flex items-start w-5/6 mx-auto',
}

export const ETopMargin = {
    LARGE:'mt-10',
    MEDIUM:'mt-7',
    SMALL:'mt-5',
}
































































































































































